import AdConsole from './Adconsole';
import Facebook from './Facebook';
import Gitlab from './Gitlab';
import Google from './Google';
import Instagram from './Instagram';
import Linkedin from './Linkedin';
import Meta from './Meta';
import Microsoft from './Microsoft';
import Passendo from './Passendo';
import Semantiq from './Semantiq';
import X from './X';
import Xandr from './Xandr';
import Yaleo from './Yaleo';
export const BrandIcons = {
    AdConsole,
    Facebook,
    Gitlab,
    Google,
    Instagram,
    Linkedin,
    Meta,
    Microsoft,
    Passendo,
    Semantiq,
    X,
    Xandr,
    Yaleo,
};
export default BrandIcons;
